<template>
    <div class="sso-callback">
        <h2 class="sso-callback__title" v-html="$t('Login.log_in_sso-callback-title')"></h2>
        <span v-if="isProcessingSSOLogin" class="sso-callback__login-spinner spinner icon-spinner8"></span>
        <span v-else class="sso-callback__instructions" v-html="error"></span>
        <div v-if="error" class="sso-callback__link">
            <router-link class="sso-callback__link" :to="{name:'login'}">{{ $t("Login.log_in_sso-callback-login-link") }}</router-link>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'SSOLoginCallBack',
        data () {
            return {
                serviceId: this.$route.params.serviceId,
                isProcessingSSOLogin: false,
                error: null
            }
        },
        methods: {
            handleError (errorCode) {
                if (errorCode === 1112) {
                    this.error = this.$t('AgreementForm.Error.AgreementLimitReached')
                    return
                }
                this.error = this.$t('General.sth_went_wrong')
            },
            async requestSSOLogin () {
                this.error = null
                try {
                    this.isProcessingSSOLogin = true
                    const code = this.$route.query.code
                    await this.$store.dispatch('loginWithSSOAuthorizationCode', {
                        code,
                        providerId: this.serviceId,
                    })
                } catch (e) {
                    console.log('Failed to login with SSO authorization code', e)
                    this.handleError(e.code)
                    this.isProcessingSSOLogin = false
                }
            }
        },
        created () {
            if (!this.$route.query.code) {
                this.$router.push({ name: 'home' })
            } else {
                this.requestSSOLogin()
            }
        },
    }
</script>

<style lang="scss" scoped>
    .sso-callback {
        padding: 240px 0;
        display: flex;
        flex-direction: column;

        &__title {
            margin: 0 auto;
            padding: 40px 0 10px 0;
            font-size: 3rem;
        }
        &__instructions {
            margin: 0 auto;
            padding: 20px;
            font-size: 1.8rem;
            max-width: 760px;
        }

        &__instructions::v-deep ul {
            list-style: disc;
            margin: 0 0 20px 20px;
        }

        &__login-spinner {
            margin: 0 auto;
            font-size: 3rem;
            color: $black;
        }
        &__link {
            color: $orange;
            margin: 0 auto;
            font-size: 2rem;
            font-family: Nunito-Bold, sans-serif;
        }
        &__error-icon {
            margin: 10px;
        }
    }
</style>
